export enum IdentificationType {
    Passport = 'Passport',
    IdCard = 'IdCard',
    LivingPermit = 'LivingPermit',
    DriversLicense = 'DriversLicense',
    ResidenceTitle = 'ResidenceTitle',
    PassportNonEu = 'PassportNonEu',
}